/**
 * IncidentReportPage · v2.6.9 batch Q
 *
 * Standalone driver-facing page at `/incident-report`. Renders the shared
 * IncidentReportForm + a list of the driver's previously-submitted reports
 * with their current dispatch-side status (audit-trail summary visible to
 * the submitter — "simplified status banner" per company policy).
 */
import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "@/components/Layout";
import IncidentReportForm from "@/components/IncidentReportForm";
import { Card } from "@/components/ui/card";
import api from "@/lib/api";

export default function IncidentReportPage() {
  const nav = useNavigate();
  const [me, setMe] = useState(null);
  const [history, setHistory] = useState([]);

  const reload = useCallback(() => {
    api.get("/driver/incidents/mine").then((r) => setHistory(r.data.items || []))
      .catch((e) => console.warn("incident history fetch failed", e?.response?.status));
  }, []);

  useEffect(() => {
    api.get("/auth/me").then((r) => setMe(r.data)).catch((e) => {
      if (e?.response?.status === 401) nav("/login");
    });
    reload();
  }, [nav, reload]);

  return (
    <Layout title="Incident Commander" back={true}>
      <div className="max-w-3xl mx-auto space-y-5 px-1">
        <IncidentReportForm
          submitterType="driver"
          submitterName={me?.name}
          apiClient={api}
          submitEndpoint="/driver/incidents"
          onSubmitted={reload}
        />
        {history.length > 0 && (
          <Card className="bg-zinc-900 border-zinc-800 p-4" data-testid="driver-incident-history">
            <h3 className="font-bold text-sm mb-3 text-amber-400">Your past reports</h3>
            <div className="space-y-2">
              {history.map((i) => (
                <div key={i.id} className="flex items-center gap-2 border border-zinc-800 rounded p-3" data-testid={`incident-history-${i.id}`}>
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-semibold">{i.incident_number}</div>
                    <div className="text-[10px] text-zinc-500">
                      {i.incident_date} {i.incident_time} · {i.driver_kind || "—"}
                    </div>
                  </div>
                  <span className="text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-full bg-amber-400/10 text-amber-300 font-bold">{i.status}</span>
                </div>
              ))}
            </div>
          </Card>
        )}
      </div>
    </Layout>
  );
}
